module.exports = __webpack_public_path__ + "static/Ygor-507947d6541fedc36de515eb65abfda9.jpg";